import { Box, Button, Container, Grid, Typography } from '@mui/material'
import React from 'react'
import { Formik, Form, Field } from "formik";
import { TextField as MuiTextField } from 'formik-mui';
import * as Yup from 'yup';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { alertMsg } from '../../utils/basicUtils';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import { axiosPrivate } from '../../utils/apiUtils';
import { useSearchParams } from "react-router-dom"
import Navbar from '../../components/Navbar';
import useAxios from "../../hooks/use-axios";
import { CircularProgress } from '@mui/material';
import { pink } from '@mui/material/colors';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useEffect } from "react"
import InputAdornment from '@mui/material/InputAdornment';
const ResetPassword = () => {
    const navigate = useNavigate();
    const [isShowPassword, setIsShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const [paramsString] = useSearchParams();
    const axios = useAxios()
    const [forgetPasswordStatus, setForgetPasswordStatus] = useState('LOADING')
    const activateForgetPassword = async () => {
        try {
            const resp = await axios.get('accounts/reset_password/', {
                params: {
                    uid: paramsString.get('uid'), token: paramsString.get('token')
                }
            })
            setForgetPasswordStatus(resp.data.data.reason)
        }
        catch (error) {
            console.error(error)
            setForgetPasswordStatus(error.response.data.data.reason)
        }
    }

    useEffect(() => {
        activateForgetPassword()
    }, [])
    switch (forgetPasswordStatus) {
        case 'LINK_VALID':
            return (
                <div>
                    <Navbar></Navbar>
                    <Container maxWidth="md" sx={{ minHeight: "calc(100vh - 75px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Grid container sx={{ justifyContent: "center", my: 3 }}>
                            <Grid item xs={12} sm={10} md={8}>
                                <Box sx={{ boxShadow: "0 5px 15px rgb(63 81 181 / 12%)", borderRadius: "6px", p: { xs: 2, sm: 3, md: 5 } }}>
                                    <Box sx={{ mt: 2, textAlign: "center" }}>
                                        <Typography sx={{ fontWeight: 500, fontSize: { xs: 22, sm: 25, md: 30 } }}>Reset Password</Typography>
                                    </Box>
                                    <Formik
                                        initialValues={{
                                            password: '',
                                            confirm_password: '',
                                        }}
                                        validationSchema={
                                            Yup.object({
                                                password: Yup.string()
                                                    .required('Password is required')
                                                    .min(8, "Must be at least 8 characters")
                                                    .max(12, "Password cannot exceed 12 characters"),
                                                confirm_password: Yup.string()
                                                    .required("confirm password is required")
                                                    .oneOf([Yup.ref('password'), null], "Passwords doesn't match"),
                                            })
                                        }
                                        onSubmit={async (values, { setSubmitting, resetForm }) => {
                                            try {
                                                const response = await axiosPrivate.post("accounts/save_forgot_password/",
                                                    {
                                                        uid: paramsString.get('uid'),
                                                        token: paramsString.get('token'),
                                                        password: values.password
                                                    }
                                                )
                                                alertMsg(response.data.message, 'success')
                                                resetForm()
                                                console.log(response)
                                            }
                                            catch (error) {
                                                console.error(error)
                                            }
                                            setSubmitting(false);
                                        }}
                                    >

                                        {
                                            ({ isSubmitting, submitForm }) => {
                                                return (
                                                    <Form>
                                                        <Box>
                                                            <Box sx={{ mt: 4, position: "relative" }}>
                                                                <Field
                                                                    component={MuiTextField}
                                                                    name="password"
                                                                    label="Password"
                                                                    type={!isShowPassword ? "password" : "text"}
                                                                    fullWidth
                                                                    InputProps={{
                                                                        endAdornment:
                                                                            <InputAdornment position="end">
                                                                                <IconButton
                                                                                    onClick={() => { setIsShowPassword(prev => !prev) }}
                                                                                    edge="end"
                                                                                >
                                                                                    {!isShowPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                    }}
                                                                />
                                                            </Box>
                                                            <Box sx={{ mt: 4, position: "relative" }}>
                                                                <Field
                                                                    component={MuiTextField}
                                                                    name="confirm_password"
                                                                    label="Confirm New password *"
                                                                    type={!showConfirmPassword ? "password" : "text"}
                                                                    inputProps={{ maxLength: 15 }}
                                                                    fullWidth
                                                                    InputProps={{
                                                                        endAdornment:
                                                                            <InputAdornment position="end">
                                                                                <IconButton
                                                                                    onClick={() => { setShowConfirmPassword(prev => !prev) }}
                                                                                    edge="end"
                                                                                >
                                                                                    {!showConfirmPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                    }}
                                                                />
                                                            </Box>
                                                        </Box>
                                                        <Box sx={{ mt: 3, textAlign: "center" }}>
                                                            <Button size='large' variant="outlined"
                                                                disabled={isSubmitting} onClick={(e) => {
                                                                    if (e.detail === 1) {
                                                                        submitForm()
                                                                        setTimeout(() => {
                                                                            navigate('/accounts/signin')
                                                                        }, 5000)
                                                                    }
                                                                }}>Submit</Button>
                                                        </Box>
                                                    </Form>
                                                )
                                            }
                                        }
                                    </Formik>
                                </Box>
                            </Grid>
                        </Grid>
                    </Container>
                </div >
            )
        case 'LINK_ALREADY_USED':
            return (
                <>
                    <Box sx={{ textAlign: "center", mt: 2 }}>
                        <ErrorOutlineIcon sx={{ fontSize: "60px", color: pink[500] }}></ErrorOutlineIcon>
                    </Box>
                    <Box sx={{ mt: 2, textAlign: "center" }}>
                        <Typography sx={{ fontWeight: 500, fontSize: "26px" }}>Reset password link is already used</Typography>
                    </Box>
                </>
            )
        case 'LINK_EXPIRED':
            return (
                <>
                    <Box sx={{ textAlign: "center", mt: 2 }}>
                        <ErrorOutlineIcon sx={{ fontSize: "60px", color: pink[500] }}></ErrorOutlineIcon>
                    </Box>
                    <Box sx={{ mt: 2, textAlign: "center" }}>
                        <Typography sx={{ fontWeight: 500, fontSize: "26px" }}>Reset password link is expired</Typography>
                    </Box>
                    <Box sx={{ mt: 3, textAlign: "center", mb: 3 }}>
                        <Button variant='contained' type="submit" color="error" onClick={() => { navigate('/accounts/signin') }}>Back To Home</Button>
                    </Box>
                </>
            )

        case 'LINK_INVALID':
            return (
                <>
                    <Box sx={{ textAlign: "center", mt: 2 }}>
                        <ErrorOutlineIcon sx={{ fontSize: "60px", color: pink[500] }}></ErrorOutlineIcon>
                    </Box>
                    <Box sx={{ mt: 2, textAlign: "center" }}>
                        <Typography sx={{ fontWeight: 500, fontSize: "26px" }}>Reset password link is invalid</Typography>
                    </Box>
                    <Box sx={{ mt: 3, textAlign: "center", mb: 3 }}>
                        <Button variant='contained' type="submit" color="error" onClick={() => { navigate('/accounts/signin') }}>Back To Home</Button>
                    </Box>
                </>
            )
        case 'LOADING':
            return (
                <>
                    <Box sx={{ textAlign: "center", mt: 2 }}>
                        <CircularProgress />
                    </Box>
                    <Box sx={{ mt: 2, textAlign: "center" }}>
                        <Typography sx={{ fontWeight: 500, fontSize: "26px" }}>Validating password link</Typography>
                    </Box>
                    <Box sx={{ mt: 1, textAlign: "center" }}>
                        <Typography sx={{ fontWeight: 400, fontSize: "16px" }}>Please wait while we validating your reset password link </Typography>
                    </Box>
                </>
            )
        default:
            return (
                <>
                    <Box sx={{ textAlign: "center", mt: 2 }}>
                        {/* <LoopIcon sx={{ fontSize: "60px", color: pink[500] }}></LoopIcon> */}
                        <ErrorOutlineIcon sx={{ fontSize: "60px", color: pink[500] }}></ErrorOutlineIcon>
                    </Box>
                    <Box sx={{ mt: 2, textAlign: "center" }}>
                        <Typography sx={{ fontWeight: 500, fontSize: "26px" }}>Unable to reset password</Typography>
                    </Box>
                    <Box sx={{ mt: 3, textAlign: "center", mb: 3 }}>
                        <Button variant='contained' type="submit" color="error" onClick={activateForgetPassword}>try again</Button>
                    </Box>
                </>
            )
    }
}

export default ResetPassword